(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["topbar"] && !Shopify.designMode) return;
  try {
    
  class Topbar extends HTMLElement {
    constructor() {
      super();
      this.container = this.querySelector('.swiper');
      this.topbarSliderWrapper = this.querySelector('.swiper-wrapper');
      this.carousel = null;
      this.isInitialized = false;

      // Initialize on page load
      document.addEventListener('page:loaded', () => {
        setTimeout(() => {
          this.handleResize();
        }, 1000);
      });

      // Handle window resize
      window.addEventListener(
        'resize',
        this.debounce(() => {
          this.handleResize();
        }, 250)
      );
    }

    get getSlideItems() {
      return (this._cachedSlideItems = this._cachedSlideItems || Array.from(this.topbarSliderWrapper.children));
    }

    debounce(func, wait) {
      let timeout;
      return function executedFunction(...args) {
        const later = () => {
          clearTimeout(timeout);
          func(...args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
      };
    }

    shouldInitializeSlider() {
      return window.innerWidth < 768;
    }

    handleResize() {
      if (this.getSlideItems.length > 1) {
        if (this.shouldInitializeSlider() && !this.isInitialized) {
          this.initializeCarousel();
        } else if (!this.shouldInitializeSlider() && this.isInitialized) {
          this.destroyCarousel();
        }
      }
    }

    initializeCarousel() {
      if (this.isInitialized) return;

      this.topbarSliderWrapper.classList.add('swiper-wrapper--initialized');

      const sliderOptions = {
        centeredSlides: false,
        direction: 'vertical',
        effect: 'slide',
        slidesPerView: 1,
        loop: true,
        autoplay: { delay: 3000, pauseOnMouseEnter: true },
      };

      this.carousel = new FoxTheme.Carousel(this.container, sliderOptions, [FoxTheme.Swiper.Autoplay]);
      this.carousel && this.carousel.init();
      this.isInitialized = true;

      if (Shopify.designMode) {
        this.addEventListener('shopify:block:select', (event) => {
          if (this.carousel && this.carousel.slider) {
            this.carousel.slider.slideToLoop(this.getSlideItems.indexOf(event.target));
          }
        });
      }
    }

    destroyCarousel() {
      if (this.carousel && this.carousel.slider) {
        this.carousel.slider.destroy(true, true);
        this.carousel = null;
        this.isInitialized = false;

        this.topbarSliderWrapper.classList.remove('swiper-wrapper--initialized');
      }
    }
  }

  customElements.define('top-bar', Topbar);

  } catch(e) { console.error(e); }
})();
})();
